import React from 'react'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TasteOfGoldHeroLogo from './TasteOfGoldHeroLogo'
import GoldText from './GoldText'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'

/**
 * Hero carousel title for the Taste of Gold campaign (LERE off).
 * Logo is embedded inline because HeroOfferCarouselSection only renders
 * logos via iconPlacement which is for Lab payloads only.
 */
function TasteOfGoldHeroTitleContent() {
  return <Group direction="horizontal" gap={16} verticalAlign="center">
    <CSSBreakpoint min="tablet">
      <TasteOfGoldHeroLogo />
    </CSSBreakpoint>
    <GoldText>Experience <i>{getLoyaltyProgramDisplayName()} {getLoyaltyTierDisplayName('gold')}</i></GoldText>
  </Group>
}

export default TasteOfGoldHeroTitleContent
